<template>
  <div class="container">
    <div class="header">
      <div class="photo text-color-primary" >
        <div class="frameImg"></div>
      </div>
      <div class="aboutMe text-color-primary">
        <span>@bcazu</span>
      </div>
      <div class="menu">
        <a class="menu-portafolio text-color-primary" href="#portafolio">Portafolio</a>
        <a class="menu-aboutme text-color-primary" href="#time-line">Acerca de</a>
        <a class="menu-habilies text-color-primary" href="#tecnologias">Tecnologías</a>
        <a
          class="menu-cv text-color-primary"
          href="https://drive.google.com/file/d/1DUNvTR9EkSrD8gbnsQELP1PX1SuL57q0/view?usp=drive_link"
          target="_blank"
          >CV</a
        >
      </div>
    </div>
    <div class="section">
      <div class="portafolio" id="portafolio">
        <Title title="Portafolio" :styles="{}"></Title>
        <div class="contentCode">
          <Card v-for="card in filteredList" :key="card.id" :code="card"></Card>
        </div>
      </div>
      <div class="time-line" id="time-line">
        <Title title="Acerca de mí" :styles="{}"></Title>
        <Time :list="listEvents"></Time>
      </div>
      <div class="tecnologias" id="tecnologias">
        <Title title="Tecnologías" :styles="{}"></Title>
        <Tools :tools="toolsList" />
      </div>
    </div>
    <div class="footer">
      <a title="gitlab" href="https://gitlab.com/bcazu" target="_blank"
        ><font-awesome-icon :icon="['fab', 'gitlab']" style="color:#fca326"
      /></a>
      <a title="github" href="https://github.com/bcazu" target="_blank"
        ><font-awesome-icon :icon="['fab', 'github']" style="color:black"
      /></a>
      <a
        title="linkedin"
        href="https://www.linkedin.com/in/brayan-stiven-casta%C3%B1o-zuluaga-7ba1b7161/"
        target="_blank"
        ><font-awesome-icon :icon="['fab', 'linkedin']" style="color:#0073b1"
      /></a>
      <a
        title="telegram"
        href="https://t.me/bcazu"
        target="_blank"
        ><font-awesome-icon :icon="['fab', 'telegram']" style="color:#279ed9"
      /></a>
      <span ><a class="text-color-primary" href="mailto:bcastano02@gmail.com">Contacto</a></span>
    </div>
  </div>
</template>
<script>
import Title from "./components/Title/Title.vue";
import Card from "./components/Card/Card.vue";
import Time from "./components/TimeLine/TimeLine.vue";
import Tools from "./components/Tools/Tools.vue";
import TOOLS from "./data/tools.json";
import PROJECT_LIST from "./data/projectsInformation.json";
import TIME_LINE_EVENTS from "./data/timeLineEvents.json";

export default {
  name: "App",
  components: {
    Title,
    Card,
    Time,
    Tools,
  },
  methods: {},
  data() {
    return {
      listSection: PROJECT_LIST,
      listEvents: TIME_LINE_EVENTS,
      toolsList: TOOLS,
    };
  },
  computed: {
    filteredList() {
      return this.listSection.code.filter((item) => item.show === true);
    },
  },
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
}
body {
  font-weight: 400;
  letter-spacing: 0.025em;
  background: #fff;
  font-family: "Roboto Mono", Monaco, courier, monospace;
  -webkit-font-smoothing: initial;
  -moz-osx-font-smoothing: initial;
}
.text-color-primary{
  color: #3A6889 !important;
}
.container {
  display: grid;
  /* FILAS / COLUMNAS */
  grid-template-rows: 100px 1fr 70px;
  grid-template-columns: 1fr 950px 1fr;
  grid-template-areas:
    ". header ."
    ". section ."
    ". footer .";
  justify-items: center;
}
.container .header {
  width: 100%;
  background: rgba(248, 248, 248,0.7);
  grid-area: header;
  text-align: center;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 130px 1fr 1fr;
  grid-template-areas: "photo aboutMe menu";
  gap: 10px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
  align-items: center;
}
.container .header .photo {
  grid-area: photo;
  align-self: center;
  justify-self: start;
  padding: 0 1em;
}
.container .header .aboutMe {
  justify-self: start;
  grid-area: aboutMe;
  padding: 10px 0 10px 0;
  font-size: 35px;
  letter-spacing: 2px;
  font-weight: bold;
}
.container .header .menu {
  grid-area: menu;
  display: grid;
  gap: 10px;
  grid-template-columns: 80px 120px 80px 50px;
  grid-template-rows: 1fr;
  align-items: end;
  justify-items: center;
  justify-content: end;
}
.menu-portafolio,
.menu-aboutme,
.menu-habilies,
.menu-cv {
  text-decoration: underline #3A6889;
  transition: all 0.2s ease-out, all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out, all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out, all 0.2s ease-out;
  -ms-transition: all 0.2s ease-out, all 0.2s ease-out;
  -o-transition: all 0.2s ease-out, all 0.2s ease-out;
}
.menu-cv {
  font-weight: bold;
}
.menu-portafolio:hover,
.menu-aboutme:hover,
.menu-habilies:hover,
.menu-cv:hover {
  color: #fff;
  background: #41b882;
  padding: 0 5px; 
  text-decoration: none;
}

.container .header .photo .frameImg {
  width: 80px;
  height: 80px;
  border: solid #3A6889 5px;
  border-radius: 3em;
  background-image: url("./assets/photo.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.container .section {
  grid-area: section;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  justify-items: center;
  align-items: center;
}
.portafolio,
.time-line,
.tecnologias {
  padding: 1.5em 0 2em 0;
  width: 100%;
}
.container .section .contentCode {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;
  align-items: start;
  width: 95%;
  margin: 0 auto;
}
.container .footer {
  grid-area: footer;
  text-align: center;
  display: grid;
  grid-template-columns: repeat(5, 35px) auto;
  grid-template-rows: 1fr;
  justify-content: center;
  align-items: center;
}
.container .footer a {
  text-decoration: none;
  font-size: 20px;
}

.container .footer span a {
  padding: 5px;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.2s ease-out, all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out, all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out, all 0.2s ease-out;
  -ms-transition: all 0.2s ease-out, all 0.2s ease-out;
  -o-transition: all 0.2s ease-out, all 0.2s ease-out;
}
.container .footer span a:hover {
  color: #fff;
  background: #41b882;
}

.highlight {
  color: #3A6889 !important;
  font-weight: bold;
}

@media (max-width: 800px) {
  .container {
    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "section"
      "footer";
  }
  .container .header {
    grid-template-columns: 1fr;
    grid-template-areas: "photo menu";
    justify-items: center;
  }
  .container .header .aboutMe{
    display: none;
  }

  .container .section .contentCode {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
  }
}
</style>
